import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { authRoles } from "../../auth/authRoles";

const PatientsSummary = Loadable(lazy(() => import("./PatientsSummary")));

const dashboardRoutes = [
  {
    path: "/dashboard/default",
    element: <PatientsSummary />,
    auth: authRoles.clinician,
  },
];

export default dashboardRoutes;
